import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

const password = 'gcare123';

function RMOnline() {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (value === password) {
      window.location.href = 'https://www.rmmonline.co.uk/?implicit-login=true';
      return;
    }

    setError('Incorrect password. Please try again.');
    setValue('');
  };

  return (
    <>
      <Helmet>
        <title>Royal Marsden Online | Graham Care</title>
        <meta
          name="description"
          content="Enter your password to access Royal Marsden Online from Graham Care."
        />
        <link rel="canonical" href="https://www.graham.care/rmonline" />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section rmonline-page">
            <div className="rmonline-container">
              <form className="rmonline-form" onSubmit={handleSubmit} noValidate>
                <p className="rmonline-form__instruction">Enter your password to continue</p>

                <label className="rmonline-form__label" htmlFor="rmonline-password">
                  Password
                </label>
                <input
                  id="rmonline-password"
                  className="rmonline-form__input"
                  type="password"
                  name="password"
                  autoComplete="current-password"
                  value={value}
                  onChange={(event) => {
                    setValue(event.target.value);
                    if (error) setError('');
                  }}
                />

                {error && (
                  <p className="rmonline-form__error" role="alert">
                    {error}
                  </p>
                )}

                <button type="submit" className="rmonline-form__submit">
                  Enter
                </button>
              </form>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Graham Care <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Graham Care Ltd, KT15 1HH</p>
                <p>Copyright © Graham Care Ltd</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default RMOnline;
